import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalContainer from '../container';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Upsell from 'routes/Checkout/components/Upsell';

const UpsellModal = props => {
  const {showModal, hideModal} = props;
  const title = "Limited Time Offer";

  return (
    <ModalContainer {...props} title={title}>
      <Grid container>
        <Grid item xs={12}>
          <Upsell />
        </Grid>
      </Grid>
    </ModalContainer>
  )
}

export default UpsellModal;


// WEBPACK FOOTER //
// ./routes/Modal/Upsell/index.jsx